export const STATUS_CREATED = 1
export const STATUS_PROCESSING = 2
export const STATUS_COMPLETED = 3
export const STATUS_PARSED = 4
export const STATUS_ERROR = 5
